import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IEnvironment } from 'src/environments/environment.model';

import { MessageItemPost, MessageItemResponse, MessageThreadPost, MessageThreadResponse } from 'src/app/modules/core/models/message.model';
import { SettingsService } from 'src/app/modules/core/services/settings.service';

import { withSpinner } from 'src/app/modules/shared/extensions/withSpinner.extension';
import { UnsubscribeOnDestroy } from 'src/app/modules/shared/utilities/unsubscribe-on-destroy';

@Injectable({
	providedIn: 'root'
})
export class MessageService extends UnsubscribeOnDestroy {	
	private settings!: IEnvironment;

	constructor(private _http: HttpClient,
		settingsService: SettingsService) {
		super();

		settingsService.getSettings().pipe(
			this.takeUntilDestroyed()
		).subscribe(settings => {
			this.settings = settings;
		});
	}
	
	getMessageThreads(salesAgreementId: number): Observable<MessageThreadResponse[]> {
		const url = `${this.settings?.apiUrl}message/salesAgreement/${salesAgreementId}/threads`;
		return this._http.get<MessageThreadResponse[]>(url);
	}

	getMessageItems(salesAgreementId: number, messageThreadId: string): Observable<MessageItemResponse[]> {
		const url = `${this.settings?.apiUrl}message/salesAgreement/${salesAgreementId}/threads/${messageThreadId}/items`;
		return this._http.get<MessageItemResponse[]>(url);
	}

	postMessageThread(salesAgreementId: number, data: MessageThreadPost, assigneeIds: number[]): Observable<MessageThreadResponse> {
		const url = `${this.settings?.apiUrl}message/salesAgreement/${salesAgreementId}/threads`;
	
		// Add assigneeIds as separate query parameters if provided
		let params = new HttpParams();
		if (assigneeIds && assigneeIds.length > 0) {
			assigneeIds.forEach(id => {
				params = params.append('assigneeIds', id.toString());
			});
		}
	
		return withSpinner(this._http).post<MessageThreadResponse>(url, data, { params });
	}

	postMessageItem(salesAgreementId: number, messageThreadId: string, data: MessageItemPost, assigneeIds: number[]): Observable<MessageItemResponse> {
		const url = `${this.settings?.apiUrl}message/salesAgreement/${salesAgreementId}/threads/${messageThreadId}/items`;

		// Add assigneeIds as separate query parameters if provided
		let params = new HttpParams();
		if (assigneeIds && assigneeIds.length > 0) {
			assigneeIds.forEach(id => {
				params = params.append('assigneeIds', id.toString());
			});
		}

		return withSpinner(this._http).post<MessageItemResponse>(url, data, { params });
	}

	markAsRead(salesAgreementId: number, messageThreadId: string): Observable<MessageThreadResponse> {
		const url = `${this.settings?.apiUrl}message/salesAgreement/${salesAgreementId}/threads/${messageThreadId}/read`;

		return this._http.put<MessageThreadResponse>(url, {});
	}
}